module.exports = __webpack_public_path__ + "static/media/no-seat-img.1e17a899.jpg";